import { render, staticRenderFns } from "./AssignmentDocuments.vue?vue&type=template&id=d629f1bc"
import script from "./AssignmentDocuments.vue?vue&type=script&lang=js"
export * from "./AssignmentDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports